import { gql } from '@apollo/client';
const REMOVE_TENANT_SUPPLIER = gql `
  mutation RemoveTenantSupplier($supplierId: ID!) {
    removeSupplier(supplierId: $supplierId) {
      removed
    }
  }
`;
export default REMOVE_TENANT_SUPPLIER;
